// extracted by mini-css-extract-plugin
module.exports = {"content":"CompanyCreatePage_content__JG-gW","stepWrapper":"CompanyCreatePage_stepWrapper__3u1pN","title":"CompanyCreatePage_title__49CgJ typography_subtitle__27VeK"};